// Resolve o mundo de origem a partir do mapa (hubWorlds.js).
// Nao altera o mapa. Usado pela barra "Voltar para <Mundo>".

import { HUB_WORLDS } from './hubWorlds';

export const FROM_WORLD_QUERY = 'from_world';

// Destinos que a visita no staging marcou com saida propria
// (seta, botao voltar ou lista lateral). Duas voltas na mesma
// tela e pior que nenhuma.
export const ROUTES_WITH_OWN_EXIT = new Set([
  'home',
  'contacts_dashboard_index',
  'contacts_dashboard_segments_index',
  'contacts_dashboard_labels_index',
  'contacts_dashboard_active',
  'account_overview_reports',
  'integration_events_report',
  'automation_logs',
]);

// Rotas que não são destino do Hub mas moram num mundo: o Hub aponta para a
// entrada da Central da IA, e a pessoa anda por áreas, itens e Ajustes.
export const ROUTE_WORLD_ALIASES = Object.freeze({
  ai_center_area: 'ai_center',
  ai_center_item: 'ai_center',
  ai_center_quick: 'ai_center',
  ai_center_campaign: 'ai_center',
  ai_settings: 'ai_center',
});

const destinationMatchesRoute = (destination, routeName) =>
  destination.routeName === routeName ||
  destination.params?.navigationPath === routeName;

export const worldsForRouteName = routeName => {
  if (!routeName) return [];
  const aliasWorld = ROUTE_WORLD_ALIASES[routeName];
  if (aliasWorld) {
    return HUB_WORLDS.filter(world => world.id === aliasWorld);
  }
  return HUB_WORLDS.filter(world =>
    world.destinations.some(destination =>
      destinationMatchesRoute(destination, routeName)
    )
  );
};

export const resolveOriginWorld = (routeName, preferredWorldId) => {
  const worlds = worldsForRouteName(routeName);
  if (!worlds.length) return null;
  if (preferredWorldId) {
    const preferred = worlds.find(world => world.id === preferredWorldId);
    if (preferred) return preferred;
  }
  return worlds[0];
};

export const preferredWorldIdFromRoute = route => {
  const fromQuery = route.query?.[FROM_WORLD_QUERY];
  if (typeof fromQuery === 'string' && fromQuery) return fromQuery;
  if (typeof window === 'undefined') return '';
  const fromState = window.history.state?.fromWorld;
  return typeof fromState === 'string' && fromState ? fromState : '';
};

export const routeNamesToMatch = route => {
  const names = [];
  if (route.name) names.push(route.name);
  (route.matched || []).forEach(record => {
    if (record.name && !names.includes(record.name)) names.push(record.name);
  });
  return names;
};

export const worldById = worldId =>
  HUB_WORLDS.find(world => world.id === worldId) || null;
